import React from "react";
import { cn } from "./cn";

export default function PageHeader({ title, subtitle, actions, className }) {
  return (
    <header
      className={cn(
        "relative overflow-hidden rounded-3xl border border-white/15 bg-mesh-hero px-5 py-7 text-white shadow-lift sm:px-8",
        className
      )}
    >
      <div className="absolute inset-0 bg-noise opacity-60 mix-blend-overlay pointer-events-none" aria-hidden />
      <div className="relative z-10 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="max-w-3xl">
          <h1 className="font-display text-3xl font-extrabold leading-tight sm:text-4xl">{title}</h1>
          {subtitle ? <p className="mt-2 text-sm text-white/85 sm:text-base">{subtitle}</p> : null}
        </div>
        {actions ? <div className="shrink-0">{actions}</div> : null}
      </div>
    </header>
  );
}
